import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface CinemasIconProps {
  color: string;
}

export const CinemasIcon: FC<CinemasIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.3846 1C17.5592 1 21.7692 5.24185 21.7692 10.4563C21.7692 16.8663 14.4253 23.1818 12.3846 23.1818C10.3439 23.1818 3 16.8663 3 10.4563C3 5.24185 7.21 1 12.3846 1ZM12.3846 2.70629C8.15073 2.70629 4.70629 6.18372 4.70629 10.4563C4.70629 15.8925 11.1038 21.1889 12.3846 21.471C13.6655 21.1877 20.0629 15.8914 20.0629 10.4563C20.0629 6.18372 16.6185 2.70629 12.3846 2.70629ZM12.3858 6.68765C14.4242 6.68765 16.0827 8.34616 16.0827 10.3858C16.0827 12.4242 14.4242 14.0816 12.3858 14.0816C10.3473 14.0816 8.68878 12.4242 8.68878 10.3858C8.68878 8.34616 10.3473 6.68765 12.3858 6.68765ZM12.3858 8.39394C11.288 8.39394 10.3951 9.2869 10.3951 10.3858C10.3951 11.4835 11.288 12.3753 12.3858 12.3753C13.4835 12.3753 14.3764 11.4835 14.3764 10.3858C14.3764 9.2869 13.4835 8.39394 12.3858 8.39394Z'
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
};
